import type { Communication } from '@medplum/fhirtypes'
import { isOfType } from '@seen/core/utils'
import type { JSX } from 'react'
import { ObservationDisplayLink } from '#src/components/ObservationDisplayLink.tsx'

interface CommentObservationsProps {
  payload: Communication['payload']
}

export function CommentObservations({
  payload,
}: CommentObservationsProps): JSX.Element | null {
  const observationRefs = payload
    ?.map((p) => p.contentReference)
    ?.filter((r) => isOfType(r, 'Observation'))

  if (!observationRefs || observationRefs.length === 0) {
    return null
  }

  return (
    <div className="mt-2 flex flex-wrap gap-3">
      {observationRefs.map((ref) => (
        <ObservationDisplayLink
          key={ref.reference}
          reference={ref}
          omitDateTime
        />
      ))}
    </div>
  )
}
